import {
    LOGIN_BUTTON,
    LOGIN_I_FORGOT_PASSWORD,
    LOGIN_NOT_REGISTERED_YET_THEN_url,
    LOGIN_PASSWORD,
    LOGIN_REGISTER_HERE,
    LOGIN_USERNAME_OR_EMAIL,
} from 'mk/autogenerated/translations/LoginForm.4df6fc19b278cd3adf9a66c9a59326a8'
import { password_reset_url } from 'mk/urls/functions';
import { signupUrl } from 'mk2/apps/users/urls';
import InputField from 'mk2/components/forms/InputField';
import PasswordField from 'mk2/components/forms/PasswordField';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import React from 'react';
import styles from './LoginForm.mscss';

export const LOGIN_FORM_NAME = 'LOGIN_FORM';

interface OwnProps {
    initialValues: LoginFormData;
    onLogin(values: LoginFormData);
}

interface OwnState {
    passwordAutofillTriggered: boolean;
    usernameAutofillTriggered: boolean;
}

export interface LoginFormData {
    username: string;
    password: string;
}

type Props = OwnProps;

class LoginFormComponent extends React.Component<Props & MKReduxFormInjectedProps<LoginFormData, Props>, OwnState> {

    public state: OwnState = {
        passwordAutofillTriggered: false,
        usernameAutofillTriggered: false,
    };

    public render() {
        const { handleSubmit } = this.props;

        return (
            <div className={styles.LoginForm}>

                <form onSubmit={handleSubmit}>
                    <InputField
                        name="username"
                        type="text"
                        label={LOGIN_USERNAME_OR_EMAIL}
                        autoCapitalize="off"
                        autoCorrect="off"
                        marginLeft={false}
                        onAutofill={this.handleUsernameAutofill}
                        minimizedLabel={this.state.usernameAutofillTriggered}
                    />
                    <PasswordField
                        name="password"
                        label={LOGIN_PASSWORD}
                        marginLeft={false}
                        onAutofill={this.handlePasswordAutofill}
                        minimizedLabel={this.state.passwordAutofillTriggered}
                    />

                    <SubmitButton
                        className={styles.LoginForm__button}
                        formName={LOGIN_FORM_NAME}
                        label={LOGIN_BUTTON}
                        disableIfNotDirty={false}
                    />
                </form>

                <p className={styles.LoginForm__forgot}>
                    <a href={password_reset_url()}>{LOGIN_I_FORGOT_PASSWORD}</a>
                </p>

                <p className={styles.LoginForm__register} >
                    <Interpolate
                        i18nKey={LOGIN_NOT_REGISTERED_YET_THEN_url}
                        url={<Link to={signupUrl}>{LOGIN_REGISTER_HERE}</Link>}
                    />
                </p>
            </div>
        );
    }

    private handlePasswordAutofill = () => {
        this.setState({passwordAutofillTriggered: true});
    };

    private handleUsernameAutofill = () => {
        this.setState({usernameAutofillTriggered: true});
    };
}

export const LoginForm = mkReduxFormNew<LoginFormData, Props>({
    formName: LOGIN_FORM_NAME,
    onValidate: () => ({/* nothing to do */}),
    onSave: (values, props) => props.onLogin(values),
    disableDirtyCheck: true,
})(LoginFormComponent);
